// extracted by mini-css-extract-plugin
module.exports = {"icon":"Button_icon__1DLEj","styled":"Button_styled__2nDkA","margin":"Button_margin__2Eqky"};